import { UserRole } from "@custom-types/user"

export const GraphBuilderPagePath = "/Build"
export const GraphBuilderPageRequiredRoles = [UserRole.BUILDER] // one of
